// extracted by mini-css-extract-plugin
module.exports = {"Component":"AppLink_Component__OWBUw"};